export const getToken = () => localStorage.getItem('@porky:token')

export const setToken = token => localStorage.setItem('@porky:token', token)

export const clearToken = () => localStorage.removeItem('@porky:token')
